import { api, apiFetch } from "./api";

export type AdminUser = {
  id: number;
  email: string;
  nome: string;
};

type LoginResponse = {
  token: string;
  admin: AdminUser;
  mustChangePassword: boolean;
};

export function getStoredAdmin(): AdminUser | null {
  const raw = localStorage.getItem("udi_admin_user");
  if (!raw) return null;
  try {
    return JSON.parse(raw) as AdminUser;
  } catch {
    return null;
  }
}

export function getStoredToken(): string | null {
  return localStorage.getItem(api.jwtKey);
}

export function isAdminLogged(): boolean {
  const token = getStoredToken();
  if (!token) return false;
  // Decode JWT exp sem verificar assinatura (UI hint apenas; o Worker valida de verdade).
  try {
    const [, payload] = token.split(".");
    if (!payload) return false;
    const decoded = JSON.parse(atob(payload.replace(/-/g, "+").replace(/_/g, "/"))) as {
      exp?: number;
    };
    if (decoded.exp && decoded.exp * 1000 < Date.now()) return false;
    return true;
  } catch {
    return false;
  }
}

export async function adminLogin(email: string, password: string): Promise<LoginResponse> {
  const res = await apiFetch<LoginResponse>("/admin/auth/login", {
    method: "POST",
    body: { email, password },
  });
  localStorage.setItem(api.jwtKey, res.token);
  localStorage.setItem("udi_admin_user", JSON.stringify(res.admin));
  return res;
}

export function adminLogout(): void {
  localStorage.removeItem(api.jwtKey);
  localStorage.removeItem("udi_admin_user");
}

export async function changePassword(currentPassword: string, newPassword: string) {
  return apiFetch<{ ok: true }>("/admin/account/password", {
    method: "POST",
    body: { currentPassword, newPassword },
    auth: "admin",
  });
}
